import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=7becc1cd&scoped=true"
import script from "./marquee.vue?vue&type=script&lang=js"
export * from "./marquee.vue?vue&type=script&lang=js"
import style0 from "./marquee.vue?vue&type=style&index=0&id=7becc1cd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7becc1cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7becc1cd')) {
      api.createRecord('7becc1cd', component.options)
    } else {
      api.reload('7becc1cd', component.options)
    }
    module.hot.accept("./marquee.vue?vue&type=template&id=7becc1cd&scoped=true", function () {
      api.rerender('7becc1cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/marquee.vue"
export default component.exports